import { render, staticRenderFns } from "./Redes.vue?vue&type=template&id=396d850e&scoped=true&"
import script from "./Redes.vue?vue&type=script&lang=js&"
export * from "./Redes.vue?vue&type=script&lang=js&"
import style0 from "./Redes.vue?vue&type=style&index=0&id=396d850e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d850e",
  null
  
)

export default component.exports